<div class="p-4 flex flex-col gap-y-6 basis-full flex-grow app-full-height">
  <h1>Reports</h1>

  <mat-card appearance="outlined">
    <mat-card-content>
      <h2>Outstanding Balance Report</h2>
      <p>
        Displays a list of hire contracts and hire invoices that have an
        outstanding balance
      </p>
      <a [routerLink]="['/reports/balance']" mat-flat-button>Go to Report</a>
    </mat-card-content>
  </mat-card>
  <mat-card appearance="outlined">
    <mat-card-content>
      <h2>Contract Status Report</h2>
      <p>
        Displays a list of contracts and invoices, filtered by their status,
        created date, or invoice date
      </p>
      <a [routerLink]="['/reports/dockets']" mat-flat-button>Go to Report</a>
    </mat-card-content>
  </mat-card>

  <mat-card appearance="outlined">
    <mat-card-content>
      <h2>Account Transfer Report</h2>
      <p>
        Displays a list of hire, sales, repair invoices and payments that have
        attempted to be sent or are due to be sent, filterable by their status,
        created date, and type.
      </p>
      <a [routerLink]="['/reports/account-transfer']" mat-flat-button>Go to Report</a>
    </mat-card-content>
  </mat-card>

  <mat-card appearance="outlined">
    <mat-card-content>
      <h2>Payments Report</h2>
      <p>
        Report on payments received in HireLogic for bookings, contracts and
        invoices. Filter by date, user, location and more.
      </p>
      <a [routerLink]="['/reports/payments']" mat-flat-button>Go to Report</a>
    </mat-card-content>
  </mat-card>

  <mat-card appearance="outlined">
    <mat-card-content>
      <h2>Item Profitability Report</h2>
      <p>
        Compares the revenue generated from your hire stock with their initial
        cost and maintenance costs, maintenance costs are determined from
        workshop jobs logged for the item.
      </p>
      <a [routerLink]="['/reports/item-profitability']" mat-flat-button>Go to Report</a>
    </mat-card-content>
  </mat-card>

  <mat-card appearance="outlined">
    <mat-card-content>
      <h2>Transport Jobs Report</h2>
      <p>
        Displays a list of transport jobs, filterable by date and assignee, enabling analysis of due dates and
        completion times.
      </p>
      <a [routerLink]="['/reports/transport-jobs']" mat-flat-button>Go to Report</a>
    </mat-card-content>
  </mat-card>

  <mat-card appearance="outlined">
    <mat-card-content>
      <h2>Batch Invoice Report</h2>
      <p>
        Report on all active hire contracts and perform rollover in bulk.
      </p>
      <a [routerLink]="['/reports/batch-invoice']" mat-flat-button>Go to Report</a>
    </mat-card-content>
  </mat-card>
</div>